import React, { useState } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import Dialog from 'components/Dialog';
import DeleteWidget from 'containers/Dashboard/Popups/components/Stepper/helpers/components/DeleteWidget';
import WidgetButton from '../../WidgetButton';

const useStyles = makeStyles({
  icon: {
    fontSize: 'medium'
  },
  tooltip: {
    fontSize: '13px',
    padding: '10px',
    maxWidth: '420px'
  }
});

const DeleteButton = ({ id, dispatchDashboard }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  const handleMaximizeClick = () => {
    setIsOpen(true);
  };

  const handleMaximizeClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <WidgetButton onClick={handleMaximizeClick}>
        <DeleteForeverOutlinedIcon className={classes.icon} />
      </WidgetButton>
      <Dialog
        isOpen={isOpen}
        onClose={handleMaximizeClose}
        hasBorder
        backdrop="#346C9F73"
        maxWidth="sm"
      >
        <DeleteWidget onClose={handleMaximizeClose} id={id} dispatchDashboard={dispatchDashboard} />
      </Dialog>
    </>
  );
};

DeleteButton.propTypes = {
  id: PropTypes.string.isRequired,
  dispatchDashboard: PropTypes.func.isRequired
};

export default DeleteButton;
